import React from "react";

const industries = [
  "Fashion and clothing",
  "Luxury brands",
  "Beauty and skincare",
  "Electronics",
  "Furniture",
  "Automotive",
  "Food and beverage",
  "Health and wellness",
  "Sports equipment",
  "Industrial suppliers",
  "Home and living",
  "B2B wholesale businesses",
];

export default function Section14() {
  return (
    <div className="w-full Section14 py-[30px]">
      <div className="w-[90%] md:w-[70%] mx-auto text-center section14-container">
        <h2 className="text-[24px] md:text-[34px] font-bold text-[#151515] leading-[29px] md:leading-[41px] my-[0.67em]">
          Industries We Support
        </h2>
        <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-6">
          Our Shopify Plus development agency works with businesses across a
          wide range of industries. These include:
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-6">
          {industries.map((item, index) => (
            <span
              key={item}
              className={`px-5 py-2 rounded-full text-xs md:text-sm font-open font-bold ${
                index % 3 === 0
                  ? "bg-[#F5F5F5] text-[#373737]"
                  : "bg-[#F5F5F5] text-[#373737]"
              }`}
            >
              {item}
            </span>
          ))}
        </div>

        <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open">
          Every industry has different ecommerce challenges. We tailor each
          Shopify Plus solution to match those requirements instead of
          relying on a standard template.
        </p>
      </div>
      <div className="line mt-[55px] md:mt-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      <div className="w-[90%] md:w-[70%] mx-auto text-center pt-[30px] pb-[2%]">
      <h2 className="text-[22px] md:text-[28px] font-bold text-[#151515] leading-[28px] md:leading-[36px] my-[0.67em]">
          Let's Discuss Your Shopify Plus Project
        </h2>
        <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-4">
          Whether you need a brand-new enterprise store, a platform
          migration, advanced B2B functionality, or ongoing technical
          support, our team is here to help.
        </p>
        <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-4">
          We take the time to understand your business, recommend practical
          solutions, and develop a Shopify Plus store that supports
          long-term growth.
        </p>
        <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open">
          <a href='/contact-mean3' className="blue-link">Contact Mean3 today</a> to schedule a Shopify Plus consultation and
          discuss how we can help with your next ecommerce project.
        </p>
    </div>
    </div>
  );
}